import _Object$keys from 'babel-runtime/core-js/object/keys';
/**
 * children支持多层递归嵌套，但是建议最多三层
 * children和button不同时存在，因为如果有子集那么父级默认就不渲染成页面参考element-ui中导航菜单的用法
 */

// 由于开发环境中懒加载对webpack性能影响极大，故只在生产环境中使用懒加载
var _import = require('./_import_' + process.env.NODE_ENV);

function updateBtnAuth(buttons) {
  var obj = {};
  buttons.forEach(function (btn) {
    return obj[btn.id] = btn.label;
  });
  return obj;
}

function recursiveButtons(menuItem, fatherPath, nav) {
  // 当前路由有需要渲染成页面的按钮，那么当前路由渲染成router-view
  menuItem.component = _import('/RouterView', 'layout');
  // 当前路由的增加一个空的子路由，渲染当前路由
  menuItem.children = [{
    path: '',
    hideNav: true,
    meta: { nav: nav, iframeUrl: menuItem.iframeUrl },
    component: _import(fatherPath + '/' + menuItem.id)
  }];
  // 更新meta中buttons的权限
  menuItem.children[0].meta.buttons = updateBtnAuth(menuItem.buttons);
  // 找到所有的需要渲染成页面的button，加到当前路由的子路由中
  var isPageArr = menuItem.buttons.filter(function (btn) {
    return btn.isPage;
  });
  for (var j = 0; j < isPageArr.length; j++) {
    menuItem.children[j + 1] = {};
    menuItem.children[j + 1].hideNav = true;
    menuItem.children[j + 1].id = isPageArr[j].id;
    menuItem.children[j + 1].buttons = isPageArr[j].buttons;
    menuItem.children[j + 1].path = fatherPath + '/' + menuItem.id + '/' + isPageArr[j].id;
    menuItem.children[j + 1].meta = { label: isPageArr[j].label, isBread: true, nav: nav, iframeUrl: isPageArr[j].iframeUrl,buttons: updateBtnAuth(menuItem.buttons)};

    if (isPageArr[j].buttons && isPageArr[j].buttons.length > 0 && isPageArr[j].buttons.find(function (btn) {
      return btn.isPage;
    })) {
      // 还有按钮递归渲染
      recursiveButtons(menuItem.children[j + 1], fatherPath + '/' + menuItem.id, nav);
    } else if (isPageArr[j].buttons && isPageArr[j].buttons.length > 0) {
      // 有按钮，但是按钮不渲染成页面
      menuItem.children[j + 1].component = _import(fatherPath + '/' + menuItem.id + '/' + isPageArr[j].id);
      menuItem.children[j + 1].meta.buttons = updateBtnAuth(isPageArr[j].buttons);
    } else {
      // 没有按钮直接渲染
      menuItem.children[j + 1].component = _import(fatherPath + '/' + menuItem.id + '/' + isPageArr[j].id);
    }
  }
}

// 解析多层树结构下的某一树的路由权限：例如science项目下的 信息化项目、综合查询等
function parseRouter(menu) {
  var fatherPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  for (var index = 0; index < menu.length; index++) {
    if (menu[index].url) {
      menu[index].path = menu[index].url;
      continue;
    }

    // path由id的祖级叠加到当前层级，isBread标识当前层级在面包屑中是否可以被点击（参考element的菜单组件）
    menu[index].path = fatherPath + '/' + menu[index].id;
    menu[index].label = menu[index].label;

    if (menu[index].children && menu[index].children.length > 0) {
      // 如果有子级，需要在父级中加好一路由渲染层，再将真正的父级渲染到子级同级
      menu[index].component = _import('/RouterView', 'layout');
      // 如果有子级那么当前层级一定不可以被点击（参考element的菜单组件）
      menu[index].meta = {
        label: menu[index].label, isBread: false, iframeUrl: menu[index].iframeUrl
        // 递归解析子级
      };parseRouter(menu[index].children, menu[index].path);
    } else {
      // 如果没有子级直接渲染该层级，
      menu[index].component = _import(fatherPath + '/' + menu[index].id);
      // 如果没有子级那么当前层级就可以被点击
      menu[index].meta = { label: menu[index].label, isBread: true, iframeUrl: menu[index].iframeUrl };
    }

    // 递归需要渲染成页面的按钮，并拼到路由中
    if (menu[index].buttons && menu[index].buttons.length > 0 && menu[index].buttons.find(function (btn) {
      return btn.isPage;
    })) {
      recursiveButtons(menu[index], fatherPath, menu[index].path);
    }

    // 当前路由下增加按钮权限
    if (menu[index].buttons && menu[index].buttons.length > 0) {
      menu[index].meta.buttons = updateBtnAuth(menu[index].buttons);
    }

    // 更新meta中隐藏头部查询条件的权限
    if (menu[index].hideQuerys && _Object$keys(menu[index].hideQuerys).length > 0) menu[index].meta.hideQuerys = menu[index].hideQuerys;
  }
  return menu;
}

// 将权限树拉平成同一层级的数组结构，方便页面间地址栏的路由跳转
function parseAuth(auths, asyncRouter) {
  var authArr = [];
  var routerArr = [];
  auths.forEach(function (auth) {
    if (auth.children && auth.children.length > 0) {
      authArr.push(parseRouter(auth.children));
    }
  });

  routerArr = [].concat(authArr);
  asyncRouter[0].children = authArr.reduce(function (acc, val) {
    return acc.concat(val);
  }, []);

  return { async: asyncRouter, routerArr: routerArr };
}

export default {
  parseRouter: parseRouter,
  parseAuth: parseAuth
};


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/router/parser.js
// module id = null
// module chunks = 